<template>
  <div
    :class="{
      link: true,
      linkForgotPassword: $route.name === 'ForgotPassword'
    }"
    @click="$emit('backTo')"
  >
    <img
      v-if="$route.name === 'ForgotPassword'"
      class="link-img"
      src="@/assets/icons/BackTo.svg"
      alt="BackTo"
    />
    <img
      v-if="$route.name !== 'ForgotPassword'"
      class="link-img"
      src="@/assets/icons/BackToGreen.svg"
      alt="BackTo"
    />
    <span class="link-title">{{ title }}</span>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'Link',
  props: ['title']
})
export default class LinkComponent extends Vue {}
</script>

<style lang="scss" scoped>
.link {
  display: flex;
  align-items: center;
  border-radius: 8px;
  background-color: $white;
  cursor: pointer;
  .link-img {
    margin-right: 12px;
    font-size: $fourteenSize;
    line-height: $fourteenSize;
    background-color: $white;
  }
  .link-title {
    color: $main-green;
    background-color: $white;
  }
}

.linkForgotPassword {
  width: 210px;
  height: 50px;
  background-color: $ligher-grey;
  .link-img {
    margin-left: 19px;
    background-color: $ligher-grey;
  }
  .link-title {
    color: $main-text;
    background-color: $ligher-grey;
  }
}
</style>
